import React from 'react';
import genericField from './generic-field';

const Checkbox = genericField('checkbox', false);

export default Checkbox;
